import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import { computed, withDefaults } from 'vue';
  import dayjs from 'dayjs';

  export interface IProps {
    time?: string;
    format?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    time: null,
    format: { default: 'YYYY.MM.DD' }
  },
  setup(__props: any) {

const props = __props as { time?: string, format: string }

  

  const formatedTime = computed(() => {
    if (!props.time) {
      return '/';
    }
    return dayjs(props.time).format(props.format);
  });


return (_ctx: any,_cache: any) => {
  return _toDisplayString(_unref(formatedTime))
}
}

})